import { BLACK, WHITE } from "@chesshotel/chess";
import { ChessTermType, TermAction, } from "@chesshotel/types";
function getScoreChange(moveIndex, lastScore, currentScore) {
    return Math.abs(currentScore - lastScore);
}
export function detectPositiveGameInitiative(position, lastPosition) {
    const color = position.moveIndex % 2 === 1 ? WHITE : BLACK;
    let lastScore = lastPosition.score;
    let currentScore = position.score;
    const scoreChange = getScoreChange(position.moveIndex, lastScore, currentScore);
    if (scoreChange < 0.5) {
        return null;
    }
    const initiativeChange = (color == WHITE && currentScore > 0 && lastScore < 0) ||
        (color == BLACK && currentScore < 0 && lastScore > 0);
    if (initiativeChange) {
        return {
            term: ChessTermType.INITIATIVE_CHANGE,
            termAction: TermAction.PERFORM,
        };
    }
    if (lastScore < 0 && currentScore < 0) {
        lastScore = -lastScore;
        currentScore = -currentScore;
    }
    if (scoreChange < 0.7) {
        return null;
    }
    const equalToAdvantage = currentScore > lastScore && lastScore < 0.5;
    if (equalToAdvantage) {
        return {
            term: ChessTermType.EQUAL_TO_ADVANTAGE,
            termAction: TermAction.PERFORM,
        };
    }
}
export function detectNegativeGameInitiative(position, lastPosition) {
    const color = position.moveIndex % 2 === 1 ? WHITE : BLACK;
    let lastScore = lastPosition.score;
    let currentScore = position.score;
    const scoreChange = Math.abs(currentScore - lastScore);
    if (scoreChange < 0.5) {
        return null;
    }
    const initiativeChange = (color == WHITE && currentScore > 0 && lastScore < 0) ||
        (color == BLACK && currentScore < 0 && lastScore > 0);
    if (initiativeChange) {
        return {
            term: ChessTermType.INITIATIVE_CHANGE,
            termAction: TermAction.ALLOW,
        };
    }
    if (lastScore < 0 && currentScore < 0) {
        lastScore = -lastScore;
        currentScore = -currentScore;
    }
    if (scoreChange < 0.7) {
        return null;
    }
    const translationKeys = {
        color,
    };
    const advantageToEqual = currentScore < 0.5 && lastScore > currentScore;
    if (advantageToEqual) {
        return {
            term: ChessTermType.ADVANTAGE_TO_EQUAL,
            termAction: TermAction.PERFORM,
            translationKeys,
        };
    }
    const equalToAdvantageAllow = lastScore < 0.5 && currentScore > lastScore;
    if (equalToAdvantageAllow) {
        return {
            term: ChessTermType.EQUAL_TO_ADVANTAGE,
            termAction: TermAction.ALLOW,
            translationKeys,
        };
    }
}
//# sourceMappingURL=gameInitiative.js.map